const validatePhoneNumber = (str: string) => {
  return !/^\d+$/.test(str) || str.length < 8;
};
export default validatePhoneNumber;
